import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/Hyphen.svg'


const _hoisted_1 = { class: "sensors" }
const _hoisted_2 = { class: "sensors__header" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "chooseDate" }
const _hoisted_5 = { class: "date-block" }
const _hoisted_6 = { class: "date-inputs" }
const _hoisted_7 = { class: "input" }
const _hoisted_8 = { class: "input" }
const _hoisted_9 = {
  key: 0,
  class: "date-error"
}
const _hoisted_10 = {
  key: 1,
  class: "date-error"
}
const _hoisted_11 = {
  key: 1,
  class: "sensors__noData"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_SensorsMain = _resolveComponent("SensorsMain")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading || !_ctx.chartLoaded)
      ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.selectedSensors.options?.length)
          ? (_openBlock(), _createBlock(_component_Dropdown, {
              key: 0,
              class: "sensors__header-dropdown",
              "selected-option": _ctx.selectedSensors.selectedOption[0],
              options: _ctx.selectedSensors.options,
              "data-testid": "selectIndividualSensors",
              onSelectOption: _ctx.selectSensors
            }, null, 8, ["selected-option", "options", "onSelectOption"]))
          : _createCommentVNode("", true),
        (_ctx.selectedSensors.selectedOption?.length)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              class: "checkAllTemperatures-button",
              variant: "filled",
              title: _ctx.$t('checkThisTemperature') || 'Check this',
              onClick: _ctx.handleCheckRequest
            }, null, 8, ["title", "onClick"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Button, {
              class: "week-nav-button",
              variant: "bordered",
              title: _ctx.$t('prevWeek') || 'Prev week',
              onClick: _ctx.prevWeek
            }, null, 8, ["title", "onClick"]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Calendar, {
                type: "date",
                format: "DD/MM/YYYY",
                value: _ctx.dateRange.startTime,
                name: "startTime",
                onChange: _ctx.changeDate,
                onClosePanel: _ctx.closeTimePanel
              }, null, 8, ["value", "onChange", "onClosePanel"])
            ]),
            _cache[0] || (_cache[0] = _createElementVNode("img", {
              class: "date-img",
              src: _imports_0,
              alt: "Hyphen"
            }, null, -1)),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_Calendar, {
                type: "date",
                format: "DD/MM/YYYY",
                value: _ctx.dateRange.endTime,
                name: "endTime",
                onChange: _ctx.changeDate,
                onClosePanel: _ctx.closeTimePanel
              }, null, 8, ["value", "onChange", "onClosePanel"])
            ]),
            _createVNode(_component_Button, {
              class: "update-date-button",
              variant: "filled",
              style: {"margin-left":"12px"},
              title: _ctx.$t('update'),
              disabled: !_ctx.isDateCorrect || !_ctx.isSixMonthValid,
              onClick: _ctx.handleUpdateClick
            }, null, 8, ["title", "disabled", "onClick"]),
            (_ctx.canGoNextWeek)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "week-nav-button",
                  variant: "bordered",
                  style: {"margin-left":"12px"},
                  title: _ctx.$t('nextWeek') || 'Next week',
                  onClick: _ctx.nextWeek
                }, null, 8, ["title", "onClick"]))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.isSixMonthValid)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.$t('errorSixMonths') || 'Range cannot exceed 6 months'), 1))
            : _createCommentVNode("", true),
          (!_ctx.isDateCorrect)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.$t('errorDate')), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (!_ctx.loading && !_ctx.selectedSensors.options?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('noData')), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedSensorsData?.length && _ctx.pharmacy)
      ? (_openBlock(), _createBlock(_component_SensorsMain, {
          key: 2,
          pharmacy: _ctx.pharmacy,
          "line-chart-key": _ctx.lineChartKey,
          "data-line-chart": _ctx.dataLineChart,
          "alarms-sensor": _ctx.alarmsSensor,
          "is-date-correct": _ctx.isDateCorrect,
          "selected-sensors-data": _ctx.selectedSensorsData,
          "selected-option": _ctx.selectedSensors.selectedOption,
          "temperature-sensor-stamp": _ctx.temperatureSensorStamp,
          "date-range": _ctx.dateRange,
          "all-sensor-stamps": _ctx.allSensorStamps,
          onRefreshAlarms: _ctx.initAlarmsSensor
        }, null, 8, ["pharmacy", "line-chart-key", "data-line-chart", "alarms-sensor", "is-date-correct", "selected-sensors-data", "selected-option", "temperature-sensor-stamp", "date-range", "all-sensor-stamps", "onRefreshAlarms"]))
      : _createCommentVNode("", true)
  ]))
}